@if (hasSearch) {
  <div class="form-group ranking-search">
    <cpq-select #search="ngModel" [items]="unfilteredList" (onChange)="itemChosen(selectedNode)"
      [(ngModel)]='selectedNode' [name]="'search'"
      [label]="{key:'', placeholder: 'Admin.SetupSpa.Search'}"
    [type]="SelectType.Searchable" [tabindex]="-1"></cpq-select>
  </div>
}
<div class="ranking-holder" #listHolder>
  <div class="rank-header-wrapper">
    <div class="ranking-header-column">{{ 'xmlActions' | translate }}</div>
    <div class="ranking-header-column">{{ 'xsltRank' | translate }}</div>
    <div class="ranking-header-column">{{ valueLabel | translate }}</div>
    @for (dynamicColumn of dynamicColumns; track dynamicColumn) {
      <div class="ranking-header-column">
        <span >{{ dynamicColumn.text | translate }}</span>
      </div>
    }
  </div>
  <cdk-virtual-scroll-viewport #viewPort [itemSize]="41"
    [ngStyle]="{'height': nodes.length <= 9 ? nodes.length * 42 + 'px' : 490 + 'px'}" [minBufferPx]="900"
    [maxBufferPx]="900" class="cpq-scroll">
    <div #rankNodes [dragula]='"ranking-bag"' [(dragulaModel)]='nodes'>
      <div class='rank flex' *cdkVirtualFor="let item of nodes" [ngClass]="{ 'highlighted': item.highlighted, 'highlighted-rank': item.id === id, 'no-drag': item.preventDrag }"
        id='rankNode{{item.id}}'[attr.data-id]="item.id" [attr.data-position]="item.position" [attr.data-name]="item.name">

        <div class="ranking-body-column flex">
          @if (!item.preventDrag && showActionItems) {
            <cpq-button-menu [items]="actionItems" [buttonText]="'&#xe1f2;'" [data]="item"
            [btnStyleClass]="'fiori3-icon-button sap-icon options-button'" [iconStyleClass]="''" [title]="'xmlActions' | translate"></cpq-button-menu>
          }
          @if (!item.preventDrag && showRemoveNodeActionItem) {
            <button type="button" class="fiori3-icon-button delete-button" (click)="removeNode(item)" title="{{'xsltDelete' | translate}}">
              <span class="sap-icon">&#xe03d;</span>
            </button>
          }
        </div>
        <div class="ranking-body-column">
          <cpq-input [name]="'rankInputField' + item.id" [label]="{ key:'' }" [type]="'number'"
            [customClass]="'rank-input-field'" [(ngModel)]='item.position' (change)="onRankChange(item)"
          (keyup.enter)="onRankChange(item)" [disabled]="disableRankingInput || item.preventDrag"></cpq-input>
        </div>

        <div class="ranking-body-column">
          <span [matTooltip]="item.name" [matTooltipDisabled]="!item.name || item.name.length <= 15">{{ item.name | truncate:15 }}</span>
        </div>

        @for (dynamicColumn of dynamicColumns; track dynamicColumn) {
          <div class="ranking-body-dynamic-column">
            <span [matTooltip]="item[dynamicColumn.id]" [matTooltipDisabled]="!item[dynamicColumn.id] || item[dynamicColumn.id].toString().length <= 15">{{ item[dynamicColumn.id] | truncate:15 }}</span>
          </div>
        }

      </div>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
